import actions from '../../actionTypes';

export default payload => {
  return {
    type: actions.LOGIN_ERROR,
    error: true,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/reducers/auth/actions/loginError.js